import { Component, OnInit } from '@angular/core';
import {ToastrService} from "ngx-toastr";

@Component({
  selector: 'ui-toastr',
  templateUrl: './ui-toastr.component.html'
})
export class UiToastrComponent implements OnInit {

  constructor(public toastr: ToastrService) { }

  ngOnInit(): void {
  }

}
